<section class="new-login">
  <div class="new-login__left-content">
    <div class="new-login__left-content__logo-login"></div>
    @if (viewModel.messagingProfiles.indexOf('ord') === -1) {
      <div class="new-login__left-content__wellcome">Bem-vindo à <b>Área Reservada dos Comercializadores</b></div>
    } @else if (viewModel.messagingProfiles.indexOf('ord') !== -1) {
      <div class="new-login__left-content__wellcome">Bem-vindo ao <b>Portal dos ORDs.</b></div>
    }

    <span class="new-login__left-content__title-center">
      Para se registar, deve contactar o gestor de acessos do próprio comercializador.
    </span>
  </div>

  <div class="new-login__right-content">
    <div class="new-login__right-content-first">
      @if (viewModel.messagingProfiles.indexOf('ord') === -1) {
        <div class="form-group new-login__right-content-first__title">Área Reservada dos <b>Comercializadores</b></div>
      } @else if (viewModel.messagingProfiles.indexOf('ord') !== -1) {
        <div class="form-group new-login__right-content-first__title">Bem-vindo ao Portal dos ORDs.</div>
      }

      <div class="form-group new-login__right-content-first__login-detail-email">
        <div class="row">
          <div class="col-md-12">
            <div class="field">
              <scc-dsm3-input-control
                [formGroup]="viewModel.logInForm"
                formName="username"
                type="text"
                placeholder="Email"
                [validationOnTouch]="false"
                [errorsMessage]="{
                  required: 'Campo de preenchimento obrigatório.',
                  minlength: 'Deve ter no mínimo 2 carateres.',
                  invalidEmailFormat: 'Email inválido',
                  deprecatedADEmail:
                    'Conforme informação indicada abaixo, deve passar a utilizar o e-mail associado ao seu registo.',
                }"
              />
            </div>
          </div>
        </div>
      </div>

      @if (viewModel.showPassword) {
        <div class="form-group new-login__right-content-first__login-detail-password">
          <div class="field">
            <scc-dsm3-input-control
              [formGroup]="viewModel.logInForm"
              formName="password"
              type="password"
              placeholder="Password"
              [validationOnTouch]="false"
              [errorsMessage]="{
                required: 'Campo de preenchimento obrigatório.',
                minlength: 'Deve ter no mínimo 2 carateres.',
                invalid: 'Password inválida',
              }"
            />
          </div>
        </div>
      }

      <div class="new-login__right-content-first__recaptcha-block" [ngClass]="[viewModel.showReCaptcha ? '' : 'hide']">
        <div class="recaptcha-block">
          <re-captcha
            class="recaptcha"
            [siteKey]="viewModel.reCaptchaSiteKey"
            (resolved)="viewModel.getToken($event)"
          />
        </div>
      </div>

      @if (viewModel.showLoginErrorMessage) {
        <div class="form-group alert alert-danger" role="alert">Dados inválidos. Por favor tente novamente.</div>
      }

      <div class="new-login__right-content-first__button-login">
        <button
          type="submit"
          class="edp-btn btn-yellow no-margins-bottom"
          [disabled]="blockSubmitButton() || viewModel.isLoading"
          (click)="validateLogin()"
        >
          Avançar
          @if (viewModel.isLoading) {
            <img src="/assets/images/loading.svg" alt="loading" />
          }
        </button>
      </div>

      <div class="new-login__right-content-first__lost-password">
        <span class="cursor-pointer" routerLink="/login-recover">Esqueceu-se da password?</span>
      </div>
    </div>

    <div class="new-login__right-content-second">
      <span class="new-login__right-content-second__title"></span>
    </div>
  </div>
</section>
